import firebase from 'firebase';

const getQuery = channelId => firebase.firestore()
  .collection('messages')
  .where('channelId', '==', channelId)
  .where('type', '==', 'message')
  .orderBy('created', 'desc');

export const getFirstDocument = channelId => getQuery(channelId)
  .limit(1)
  .get()
  .then(res => res.docs[0]);

export const subscribeMessages = (channelId, onSnapshot, {
  startAt = null,
  startAfter = null,
  endBefore = null,
  limit = 20
} = {}) => {
  let q = getQuery(channelId);

  if (startAt) q = q.startAt(startAt);
  if (startAfter) q = q.startAfter(startAfter);
  if (endBefore) q = q.endBefore(endBefore);
  if (limit) q = q.limit(limit);

  return q.onSnapshot(onSnapshot, e => {
    console.log(channelId, startAt, startAfter, endBefore);
    console.log('subscribe error', e);
  });
};

export const editMessage = (id, data) => {
  return firebase.firestore().collection('messages').doc(id).update({
    ...data,
    modified: firebase.firestore.FieldValue.serverTimestamp()
  });
};

export const deleteMessage = messageId => {
  return firebase.firestore().collection('messages').doc(messageId).delete();
};